import { useBlocksConfig } from "@pathwright/blocks-engine"
import { BlockText } from "@pathwright/blocks/src/shared"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { useRef, useLayoutEffect, useEffect, useState } from "react"
import styled from "styled-components"

const MarkdownWrapper = styled(Content.Container)`
  .BlockText {
    ul,
    ol,
    li {
      white-space: normal;
    }
  }

  li > p {
    display: inline;
  }

  .ql-editor .BlockText ol ul > li::before {
    content: "•";
  }

  .ql-editor .BlockText ol {
    counter-reset: list-counter;
  }

  .ql-editor .BlockText ol > li {
    counter-increment: list-counter;
  }

  .ql-editor .BlockText ol > li::before {
    content: counter(list-counter) ". ";
  }

  pre {
    position: relative;
  }

  pre > .copy-button {
    opacity: 0;
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.5rem;
    // background-color: white;
    color: rgba(0, 0, 0, 0.5);
    border: none;
    cursor: pointer;
    font-size: 1rem;
    transition: opacity 0.2s;
  }

  pre:hover .copy-button {
    opacity: 1;
  }
`

const MarkdownView = ({ data: { html } }) => {
  const { templateVariables } = useBlocksConfig()
  const markdownRef = useRef(null)
  const [buttonsAdded, setButtonsAdded] = useState(false)

  const addCopyButtons = () => {
    const markdown = markdownRef.current
    if (!markdown) return

    const codeBlocks = markdown.querySelectorAll("pre.code-block")

    Array.from(codeBlocks).forEach((codeBlock) => {
      const copyButton = document.createElement("i")
      copyButton.className = "copy-button pwai-copy"
      copyButton.addEventListener("click", () => {
        navigator.clipboard.writeText(codeBlock.textContent)

        copyButton.className = "copy-button pwai-check"
        setTimeout(() => {
          copyButton.className = "copy-button pwai-copy"
        }, 1000)
      })

      codeBlock.appendChild(copyButton)
    })
  }

  useLayoutEffect(() => {
    const markdown = markdownRef.current
    if (!markdown) return

    const internalRe = new RegExp(window.location.host.replace("www.", ""), "i")

    const externalLinks = markdown.querySelectorAll(
      '.MarkdownBlock a[href*="://"]'
    )

    Array.from(externalLinks).forEach((link) => {
      if (internalRe.test(link.host)) return
      link.target = "_blank"
    })
  }, [html])

  useEffect(() => {
    if (markdownRef.current && !buttonsAdded) {
      addCopyButtons()
      setButtonsAdded(true)
    }
  }, [markdownRef.current])

  return (
    <MarkdownWrapper
      ref={markdownRef}
      flexForPrint={true}
      className="content-reset MarkdownBlock"
    >
      <BlockText html={html} templateContext={templateVariables} />
    </MarkdownWrapper>
  )
}

export default MarkdownView
